<template>
    <div class="pop-box" v-show="flage">
        <div class="close" @click="Ahide()">X</div>
        <div class="left">
            <div class="list" v-for="(item,i) in list" :key="i" :class="active==i?'active':''" @click="activeList(i)">
                <i></i>
                <span>{{item.NAME}}</span>
            </div>
        </div>
        <el-table
                :data="rightData"
                height="100%"
                style="width: 800px"
                v-if="flag"
        >
            <el-table-column
                    prop="FI"
                    label="瞬产(E4m3/d)"
                    >
            </el-table-column>
            <el-table-column
                    prop="FM"
                    label="月产量(E4m3)"
                    >
            </el-table-column>
            <el-table-column
                    prop="FQ"
                    label="日产量(E4m3)">
            </el-table-column>
            <el-table-column
                    prop="FQYD"
                    label="昨日产量(E4m3)">
            </el-table-column>
            <el-table-column
                    prop="NAME"
                    label="名称">
            </el-table-column>
            <el-table-column
                    prop="PDI"
                    label="计差(kPa)"
            >
            </el-table-column>
            <el-table-column
                    prop="PDIRH"
                    label="计差量程上限"
                    width="150">
            </el-table-column>
            <el-table-column
                    prop="PI"
                    label="计压(MPa)">
            </el-table-column>
            <el-table-column
                    prop="PIRH"
                    label="计压量程上限"
                    width="150">
            </el-table-column>
            <el-table-column
                    prop="TI"
                    label="计温(℃)">
            </el-table-column>
            <el-table-column
                    prop="TIRH"
                    label="计温量程上限"
                    width="150">
            </el-table-column>
            <el-table-column
                    prop="TIRL"
                    label="计温量程下限"
                    width="150">
            </el-table-column>
            <el-table-column
                    prop="time"
                    width="200"
                    label="时间">
            </el-table-column>
        </el-table>
        <el-table
                :data="rightData"
                height="100%"
                style="width: 800px"
               v-else
        >
            <el-table-column
                    prop="PDI"
                    label="计差(kPa)"
            >
            </el-table-column>
            <el-table-column
                    prop="PDIRH"
                    label="计差量程上限"
                    width="150">
            </el-table-column>
            <el-table-column
                    prop="PDIA"
                    label="PDIA">
            </el-table-column>
            <el-table-column
                    prop="PDIRL"
                    label="PDIRL">
            </el-table-column>
            <el-table-column
                    prop="time"
                    width="200"
                    label="时间">
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
    // import {getJName,getRightData} from './../api/index'
    export default {
        name: "PopUp",
        props:['flage'],
        data(){
            return{
                list:[
                   {
                     "NAME":"j-1",
                   },
                    {
                     "NAME":"j-2",
                   },
                    {
                     "NAME":"j-3",
                   },
                   {
                     "NAME":"j-4",
                   },
                   {
                     "NAME":"j-5",
                   },
                   {
                     "NAME":"j-6",
                   },
                   {
                     "NAME":"j-7",
                   },
                   {
                     "NAME":"j-8",
                   },
                   {
                     "NAME":"j-9",
                   },
                   {
                     "NAME":"j-10",
                   },
                   
                
                
                ],
                rightData:[
                    {
                        "FI":"100",
                        "FM":"12",
                        "FQ":"34",
                        "FQYD":"33",
                        "NAME":"j-1",
                        "PDI":"76",
                        "PDIRH":"21",
                        "PI":"3",
                        "PIRH":"4",
                        "TI":"1",
                        "TIRH":"22",
                        "TIRL":"33",
                        "time":"2022-07-12 15:35:05",
                    },
                    {
                        "FI":"100",
                        "FM":"12",
                        "FQ":"34",
                        "FQYD":"33",
                        "NAME":"j-1",
                        "PDI":"76",
                        "PDIRH":"21",
                        "PI":"3",
                        "PIRH":"4",
                        "TI":"1",
                        "TIRH":"22",
                        "TIRL":"33",
                        "time":"2022-07-12 15:35:05",
                    }
                ],
                allData:[
                    [
                        {"FI":"100",
                        "FM":"12",
                        "FQ":"34",
                        "FQYD":"33",
                        "NAME":"j-1",
                        "PDI":"76",
                        "PDIRH":"21",
                        "PI":"3",
                        "PIRH":"4",
                        "TI":"1",
                        "TIRH":"22",
                        "TIRL":"33",
                        "time":"2022-07-12 15:35:05",
                        },
                        {"FI":"100",
                        "FM":"12",
                        "FQ":"34",
                        "FQYD":"33",
                        "NAME":"j-1",
                        "PDI":"76",
                        "PDIRH":"21",
                        "PI":"3",
                        "PIRH":"4",
                        "TI":"1",
                        "TIRH":"22",
                        "TIRL":"33",
                        "time":"2022-07-12 15:35:05",
                        },
                        {"FI":"100",
                        "FM":"12",
                        "FQ":"34",
                        "FQYD":"33",
                        "NAME":"j-1",
                        "PDI":"76",
                        "PDIRH":"21",
                        "PI":"3",
                        "PIRH":"4",
                        "TI":"1",
                        "TIRH":"22",
                        "TIRL":"33",
                        "time":"2022-07-12 15:35:05",
                        },
                        {"FI":"100",
                        "FM":"12",
                        "FQ":"34",
                        "FQYD":"33",
                        "NAME":"j-1",
                        "PDI":"76",
                        "PDIRH":"21",
                        "PI":"3",
                        "PIRH":"4",
                        "TI":"1",
                        "TIRH":"22",
                        "TIRL":"33",
                        "time":"2022-07-12 15:35:05",
                        },
                        {"FI":"100",
                        "FM":"12",
                        "FQ":"34",
                        "FQYD":"33",
                        "NAME":"j-1",
                        "PDI":"76",
                        "PDIRH":"21",
                        "PI":"3",
                        "PIRH":"4",
                        "TI":"1",
                        "TIRH":"22",
                        "TIRL":"33",
                        "time":"2022-07-12 15:35:05",
                        },
                        {"FI":"100",
                        "FM":"12",
                        "FQ":"34",
                        "FQYD":"33",
                        "NAME":"j-1",
                        "PDI":"76",
                        "PDIRH":"21",
                        "PI":"3",
                        "PIRH":"4",
                        "TI":"1",
                        "TIRH":"22",
                        "TIRL":"33",
                        "time":"2022-07-12 15:35:05",
                        },
                        {"FI":"100",
                        "FM":"12",
                        "FQ":"34",
                        "FQYD":"33",
                        "NAME":"j-1",
                        "PDI":"76",
                        "PDIRH":"21",
                        "PI":"3",
                        "PIRH":"4",
                        "TI":"1",
                        "TIRH":"22",
                        "TIRL":"33",
                        "time":"2022-07-12 15:35:05",
                        },
                    ],
                    [
                        {"FI":"100",
                        "FM":"12",
                        "FQ":"34",
                        "FQYD":"33",
                        "NAME":"j-2",
                        "PDI":"76",
                        "PDIRH":"21",
                        "PI":"3",
                        "PIRH":"4",
                        "TI":"1",
                        "TIRH":"22",
                        "TIRL":"33",
                        "time":"2022-07-12 15:35:05",
                        },
                        {"FI":"100",
                        "FM":"12",
                        "FQ":"34",
                        "FQYD":"33",
                        "NAME":"j-2",
                        "PDI":"76",
                        "PDIRH":"21",
                        "PI":"3",
                        "PIRH":"4",
                        "TI":"1",
                        "TIRH":"22",
                        "TIRL":"33",
                        "time":"2022-07-12 15:35:05",
                        },
                        {"FI":"100",
                        "FM":"12",
                        "FQ":"34",
                        "FQYD":"33",
                        "NAME":"j-2",
                        "PDI":"76",
                        "PDIRH":"21",
                        "PI":"3",
                        "PIRH":"4",
                        "TI":"1",
                        "TIRH":"22",
                        "TIRL":"33",
                        "time":"2022-07-12 15:35:05",
                        },
                        {"FI":"100",
                        "FM":"12",
                        "FQ":"34",
                        "FQYD":"33",
                        "NAME":"j-2",
                        "PDI":"76",
                        "PDIRH":"21",
                        "PI":"3",
                        "PIRH":"4",
                        "TI":"1",
                        "TIRH":"22",
                        "TIRL":"33",
                        "time":"2022-07-12 15:35:05",
                        },
                        {"FI":"100",
                        "FM":"12",
                        "FQ":"34",
                        "FQYD":"33",
                        "NAME":"j-2",
                        "PDI":"76",
                        "PDIRH":"21",
                        "PI":"3",
                        "PIRH":"4",
                        "TI":"1",
                        "TIRH":"22",
                        "TIRL":"33",
                        "time":"2022-07-12 15:35:05",
                        },
                        {"FI":"100",
                        "FM":"12",
                        "FQ":"34",
                        "FQYD":"33",
                        "NAME":"j-2",
                        "PDI":"76",
                        "PDIRH":"21",
                        "PI":"3",
                        "PIRH":"4",
                        "TI":"1",
                        "TIRH":"22",
                        "TIRL":"33",
                        "time":"2022-07-12 15:35:05",
                        },
                        {"FI":"100",
                        "FM":"12",
                        "FQ":"34",
                        "FQYD":"33",
                        "NAME":"j-2",
                        "PDI":"76",
                        "PDIRH":"21",
                        "PI":"3",
                        "PIRH":"4",
                        "TI":"1",
                        "TIRH":"22",
                        "TIRL":"33",
                        "time":"2022-07-12 15:35:05",
                        },
                        {"FI":"100",
                        "FM":"12",
                        "FQ":"34",
                        "FQYD":"33",
                        "NAME":"j-2",
                        "PDI":"76",
                        "PDIRH":"21",
                        "PI":"3",
                        "PIRH":"4",
                        "TI":"1",
                        "TIRH":"22",
                        "TIRL":"33",
                        "time":"2022-07-12 15:35:05",
                        },
                        {"FI":"100",
                        "FM":"12",
                        "FQ":"34",
                        "FQYD":"33",
                        "NAME":"j-2",
                        "PDI":"76",
                        "PDIRH":"21",
                        "PI":"3",
                        "PIRH":"4",
                        "TI":"1",
                        "TIRH":"22",
                        "TIRL":"33",
                        "time":"2022-07-12 15:35:05",
                        },
                        {"FI":"100",
                        "FM":"12",
                        "FQ":"34",
                        "FQYD":"33",
                        "NAME":"j-2",
                        "PDI":"76",
                        "PDIRH":"21",
                        "PI":"3",
                        "PIRH":"4",
                        "TI":"1",
                        "TIRH":"22",
                        "TIRL":"33",
                        "time":"2022-07-12 15:35:05",
                        },
                    ],
                    [
                        {"FI":"100",
                        "FM":"12",
                        "FQ":"34",
                        "FQYD":"33",
                        "NAME":"j-3",
                        "PDI":"76",
                        "PDIRH":"21",
                        "PI":"3",
                        "PIRH":"4",
                        "TI":"1",
                        "TIRH":"22",
                        "TIRL":"33",
                        "time":"2022-07-12 15:35:05",
                        },
                        {"FI":"100",
                        "FM":"12",
                        "FQ":"34",
                        "FQYD":"33",
                        "NAME":"j-3",
                        "PDI":"76",
                        "PDIRH":"21",
                        "PI":"3",
                        "PIRH":"4",
                        "TI":"1",
                        "TIRH":"22",
                        "TIRL":"33",
                        "time":"2022-07-12 15:35:05",
                        },
                        {"FI":"100",
                        "FM":"12",
                        "FQ":"34",
                        "FQYD":"33",
                        "NAME":"j-3",
                        "PDI":"76",
                        "PDIRH":"21",
                        "PI":"3",
                        "PIRH":"4",
                        "TI":"1",
                        "TIRH":"22",
                        "TIRL":"33",
                        "time":"2022-07-12 15:35:05",
                        },
                        {"FI":"100",
                        "FM":"12",
                        "FQ":"34",
                        "FQYD":"33",
                        "NAME":"j-3",
                        "PDI":"76",
                        "PDIRH":"21",
                        "PI":"3",
                        "PIRH":"4",
                        "TI":"1",
                        "TIRH":"22",
                        "TIRL":"33",
                        "time":"2022-07-12 15:35:05",
                        },
                        {"FI":"100",
                        "FM":"12",
                        "FQ":"34",
                        "FQYD":"33",
                        "NAME":"j-3",
                        "PDI":"76",
                        "PDIRH":"21",
                        "PI":"3",
                        "PIRH":"4",
                        "TI":"1",
                        "TIRH":"22",
                        "TIRL":"33",
                        "time":"2022-07-12 15:35:05",
                        },
                        {"FI":"100",
                        "FM":"12",
                        "FQ":"34",
                        "FQYD":"33",
                        "NAME":"j-3",
                        "PDI":"76",
                        "PDIRH":"21",
                        "PI":"3",
                        "PIRH":"4",
                        "TI":"1",
                        "TIRH":"22",
                        "TIRL":"33",
                        "time":"2022-07-12 15:35:05",
                        },
                        {"FI":"100",
                        "FM":"12",
                        "FQ":"34",
                        "FQYD":"33",
                        "NAME":"j-3",
                        "PDI":"76",
                        "PDIRH":"21",
                        "PI":"3",
                        "PIRH":"4",
                        "TI":"1",
                        "TIRH":"22",
                        "TIRL":"33",
                        "time":"2022-07-12 15:35:05",
                        },
                        {"FI":"100",
                        "FM":"12",
                        "FQ":"34",
                        "FQYD":"33",
                        "NAME":"j-3",
                        "PDI":"76",
                        "PDIRH":"21",
                        "PI":"3",
                        "PIRH":"4",
                        "TI":"1",
                        "TIRH":"22",
                        "TIRL":"33",
                        "time":"2022-07-12 15:35:05",
                        },
                        {"FI":"100",
                        "FM":"12",
                        "FQ":"34",
                        "FQYD":"33",
                        "NAME":"j-3",
                        "PDI":"76",
                        "PDIRH":"21",
                        "PI":"3",
                        "PIRH":"4",
                        "TI":"1",
                        "TIRH":"22",
                        "TIRL":"33",
                        "time":"2022-07-12 15:35:05",
                        },
                    ],
                    [
                        {"FI":"100",
                        "FM":"12",
                        "FQ":"34",
                        "FQYD":"33",
                        "NAME":"j-4",
                        "PDI":"76",
                        "PDIRH":"21",
                        "PI":"3",
                        "PIRH":"4",
                        "TI":"1",
                        "TIRH":"22",
                        "TIRL":"33",
                        "time":"2022-07-12 15:35:05",
                        },
                        {"FI":"100",
                        "FM":"12",
                        "FQ":"34",
                        "FQYD":"33",
                        "NAME":"j-4",
                        "PDI":"76",
                        "PDIRH":"21",
                        "PI":"3",
                        "PIRH":"4",
                        "TI":"1",
                        "TIRH":"22",
                        "TIRL":"33",
                        "time":"2022-07-12 15:35:05",
                        },
                        {"FI":"100",
                        "FM":"12",
                        "FQ":"34",
                        "FQYD":"33",
                        "NAME":"j-4",
                        "PDI":"76",
                        "PDIRH":"21",
                        "PI":"3",
                        "PIRH":"4",
                        "TI":"1",
                        "TIRH":"22",
                        "TIRL":"33",
                        "time":"2022-07-12 15:35:05",
                        },
                        {"FI":"100",
                        "FM":"12",
                        "FQ":"34",
                        "FQYD":"33",
                        "NAME":"j-4",
                        "PDI":"76",
                        "PDIRH":"21",
                        "PI":"3",
                        "PIRH":"4",
                        "TI":"1",
                        "TIRH":"22",
                        "TIRL":"33",
                        "time":"2022-07-12 15:35:05",
                        },
                        {"FI":"100",
                        "FM":"12",
                        "FQ":"34",
                        "FQYD":"33",
                        "NAME":"j-4",
                        "PDI":"76",
                        "PDIRH":"21",
                        "PI":"3",
                        "PIRH":"4",
                        "TI":"1",
                        "TIRH":"22",
                        "TIRL":"33",
                        "time":"2022-07-12 15:35:05",
                        },
                        {"FI":"100",
                        "FM":"12",
                        "FQ":"34",
                        "FQYD":"33",
                        "NAME":"j-4",
                        "PDI":"76",
                        "PDIRH":"21",
                        "PI":"3",
                        "PIRH":"4",
                        "TI":"1",
                        "TIRH":"22",
                        "TIRL":"33",
                        "time":"2022-07-12 15:35:05",
                        },
                        {"FI":"100",
                        "FM":"12",
                        "FQ":"34",
                        "FQYD":"33",
                        "NAME":"j-4",
                        "PDI":"76",
                        "PDIRH":"21",
                        "PI":"3",
                        "PIRH":"4",
                        "TI":"1",
                        "TIRH":"22",
                        "TIRL":"33",
                        "time":"2022-07-12 15:35:05",
                        },
                        {"FI":"100",
                        "FM":"12",
                        "FQ":"34",
                        "FQYD":"33",
                        "NAME":"j-4",
                        "PDI":"76",
                        "PDIRH":"21",
                        "PI":"3",
                        "PIRH":"4",
                        "TI":"1",
                        "TIRH":"22",
                        "TIRL":"33",
                        "time":"2022-07-12 15:35:05",
                        },
                        {"FI":"100",
                        "FM":"12",
                        "FQ":"34",
                        "FQYD":"33",
                        "NAME":"j-4",
                        "PDI":"76",
                        "PDIRH":"21",
                        "PI":"3",
                        "PIRH":"4",
                        "TI":"1",
                        "TIRH":"22",
                        "TIRL":"33",
                        "time":"2022-07-12 15:35:05",
                        },
                        {"FI":"100",
                        "FM":"12",
                        "FQ":"34",
                        "FQYD":"33",
                        "NAME":"j-4",
                        "PDI":"76",
                        "PDIRH":"21",
                        "PI":"3",
                        "PIRH":"4",
                        "TI":"1",
                        "TIRH":"22",
                        "TIRL":"33",
                        "time":"2022-07-12 15:35:05",
                        },
                    ],
                    [
                        {"FI":"100",
                        "FM":"12",
                        "FQ":"34",
                        "FQYD":"33",
                        "NAME":"j-5",
                        "PDI":"76",
                        "PDIRH":"21",
                        "PI":"3",
                        "PIRH":"4",
                        "TI":"1",
                        "TIRH":"22",
                        "TIRL":"33",
                        "time":"2022-07-12 15:35:05",
                        },
                        {"FI":"100",
                        "FM":"12",
                        "FQ":"34",
                        "FQYD":"33",
                        "NAME":"j-5",
                        "PDI":"76",
                        "PDIRH":"21",
                        "PI":"3",
                        "PIRH":"4",
                        "TI":"1",
                        "TIRH":"22",
                        "TIRL":"33",
                        "time":"2022-07-12 15:35:05",
                        },
                        {"FI":"100",
                        "FM":"12",
                        "FQ":"34",
                        "FQYD":"33",
                        "NAME":"j-5",
                        "PDI":"76",
                        "PDIRH":"21",
                        "PI":"3",
                        "PIRH":"4",
                        "TI":"1",
                        "TIRH":"22",
                        "TIRL":"33",
                        "time":"2022-07-12 15:35:05",
                        },
                        {"FI":"100",
                        "FM":"12",
                        "FQ":"34",
                        "FQYD":"33",
                        "NAME":"j-5",
                        "PDI":"76",
                        "PDIRH":"21",
                        "PI":"3",
                        "PIRH":"4",
                        "TI":"1",
                        "TIRH":"22",
                        "TIRL":"33",
                        "time":"2022-07-12 15:35:05",
                        },
                        {"FI":"100",
                        "FM":"12",
                        "FQ":"34",
                        "FQYD":"33",
                        "NAME":"j-5",
                        "PDI":"76",
                        "PDIRH":"21",
                        "PI":"3",
                        "PIRH":"4",
                        "TI":"1",
                        "TIRH":"22",
                        "TIRL":"33",
                        "time":"2022-07-12 15:35:05",
                        },
                        {"FI":"100",
                        "FM":"12",
                        "FQ":"34",
                        "FQYD":"33",
                        "NAME":"j-5",
                        "PDI":"76",
                        "PDIRH":"21",
                        "PI":"3",
                        "PIRH":"4",
                        "TI":"1",
                        "TIRH":"22",
                        "TIRL":"33",
                        "time":"2022-07-12 15:35:05",
                        },
                        {"FI":"100",
                        "FM":"12",
                        "FQ":"34",
                        "FQYD":"33",
                        "NAME":"j-5",
                        "PDI":"76",
                        "PDIRH":"21",
                        "PI":"3",
                        "PIRH":"4",
                        "TI":"1",
                        "TIRH":"22",
                        "TIRL":"33",
                        "time":"2022-07-12 15:35:05",
                        },
                        {"FI":"100",
                        "FM":"12",
                        "FQ":"34",
                        "FQYD":"33",
                        "NAME":"j-5",
                        "PDI":"76",
                        "PDIRH":"21",
                        "PI":"3",
                        "PIRH":"4",
                        "TI":"1",
                        "TIRH":"22",
                        "TIRL":"33",
                        "time":"2022-07-12 15:35:05",
                        },
                    ],[
                        {"FI":"100",
                        "FM":"12",
                        "FQ":"34",
                        "FQYD":"33",
                        "NAME":"j-6",
                        "PDI":"76",
                        "PDIRH":"21",
                        "PI":"3",
                        "PIRH":"4",
                        "TI":"1",
                        "TIRH":"22",
                        "TIRL":"33",
                        "time":"2022-07-12 15:35:05",
                        },
                        {"FI":"100",
                        "FM":"12",
                        "FQ":"34",
                        "FQYD":"33",
                        "NAME":"j-6",
                        "PDI":"76",
                        "PDIRH":"21",
                        "PI":"3",
                        "PIRH":"4",
                        "TI":"1",
                        "TIRH":"22",
                        "TIRL":"33",
                        "time":"2022-07-12 15:35:05",
                        },
                        {"FI":"100",
                        "FM":"12",
                        "FQ":"34",
                        "FQYD":"33",
                        "NAME":"j-6",
                        "PDI":"76",
                        "PDIRH":"21",
                        "PI":"3",
                        "PIRH":"4",
                        "TI":"1",
                        "TIRH":"22",
                        "TIRL":"33",
                        "time":"2022-07-12 15:35:05",
                        },
                        {"FI":"100",
                        "FM":"12",
                        "FQ":"34",
                        "FQYD":"33",
                        "NAME":"j-6",
                        "PDI":"76",
                        "PDIRH":"21",
                        "PI":"3",
                        "PIRH":"4",
                        "TI":"1",
                        "TIRH":"22",
                        "TIRL":"33",
                        "time":"2022-07-12 15:35:05",
                        },
                        {"FI":"100",
                        "FM":"12",
                        "FQ":"34",
                        "FQYD":"33",
                        "NAME":"j-6",
                        "PDI":"76",
                        "PDIRH":"21",
                        "PI":"3",
                        "PIRH":"4",
                        "TI":"1",
                        "TIRH":"22",
                        "TIRL":"33",
                        "time":"2022-07-12 15:35:05",
                        },
                        {"FI":"100",
                        "FM":"12",
                        "FQ":"34",
                        "FQYD":"33",
                        "NAME":"j-6",
                        "PDI":"76",
                        "PDIRH":"21",
                        "PI":"3",
                        "PIRH":"4",
                        "TI":"1",
                        "TIRH":"22",
                        "TIRL":"33",
                        "time":"2022-07-12 15:35:05",
                        },
                        {"FI":"100",
                        "FM":"12",
                        "FQ":"34",
                        "FQYD":"33",
                        "NAME":"j-6",
                        "PDI":"76",
                        "PDIRH":"21",
                        "PI":"3",
                        "PIRH":"4",
                        "TI":"1",
                        "TIRH":"22",
                        "TIRL":"33",
                        "time":"2022-07-12 15:35:05",
                        },
                        {"FI":"100",
                        "FM":"12",
                        "FQ":"34",
                        "FQYD":"33",
                        "NAME":"j-6",
                        "PDI":"76",
                        "PDIRH":"21",
                        "PI":"3",
                        "PIRH":"4",
                        "TI":"1",
                        "TIRH":"22",
                        "TIRL":"33",
                        "time":"2022-07-12 15:35:05",
                        },
                        {"FI":"100",
                        "FM":"12",
                        "FQ":"34",
                        "FQYD":"33",
                        "NAME":"j-6",
                        "PDI":"76",
                        "PDIRH":"21",
                        "PI":"3",
                        "PIRH":"4",
                        "TI":"1",
                        "TIRH":"22",
                        "TIRL":"33",
                        "time":"2022-07-12 15:35:05",
                        },
                        {"FI":"100",
                        "FM":"12",
                        "FQ":"34",
                        "FQYD":"33",
                        "NAME":"j-6",
                        "PDI":"76",
                        "PDIRH":"21",
                        "PI":"3",
                        "PIRH":"4",
                        "TI":"1",
                        "TIRH":"22",
                        "TIRL":"33",
                        "time":"2022-07-12 15:35:05",
                        },
                        {"FI":"100",
                        "FM":"12",
                        "FQ":"34",
                        "FQYD":"33",
                        "NAME":"j-6",
                        "PDI":"76",
                        "PDIRH":"21",
                        "PI":"3",
                        "PIRH":"4",
                        "TI":"1",
                        "TIRH":"22",
                        "TIRL":"33",
                        "time":"2022-07-12 15:35:05",
                        },

                    ],[
                        {"FI":"100",
                        "FM":"12",
                        "FQ":"34",
                        "FQYD":"33",
                        "NAME":"j-7",
                        "PDI":"76",
                        "PDIRH":"21",
                        "PI":"3",
                        "PIRH":"4",
                        "TI":"1",
                        "TIRH":"22",
                        "TIRL":"33",
                        "time":"2022-07-12 15:35:05",
                        },
                        {"FI":"100",
                        "FM":"12",
                        "FQ":"34",
                        "FQYD":"33",
                        "NAME":"j-7",
                        "PDI":"76",
                        "PDIRH":"21",
                        "PI":"3",
                        "PIRH":"4",
                        "TI":"1",
                        "TIRH":"22",
                        "TIRL":"33",
                        "time":"2022-07-12 15:35:05",
                        },
                        {"FI":"100",
                        "FM":"12",
                        "FQ":"34",
                        "FQYD":"33",
                        "NAME":"j-7",
                        "PDI":"76",
                        "PDIRH":"21",
                        "PI":"3",
                        "PIRH":"4",
                        "TI":"1",
                        "TIRH":"22",
                        "TIRL":"33",
                        "time":"2022-07-12 15:35:05",
                        },
                        {"FI":"100",
                        "FM":"12",
                        "FQ":"34",
                        "FQYD":"33",
                        "NAME":"j-7",
                        "PDI":"76",
                        "PDIRH":"21",
                        "PI":"3",
                        "PIRH":"4",
                        "TI":"1",
                        "TIRH":"22",
                        "TIRL":"33",
                        "time":"2022-07-12 15:35:05",
                        },
                        {"FI":"100",
                        "FM":"12",
                        "FQ":"34",
                        "FQYD":"33",
                        "NAME":"j-7",
                        "PDI":"76",
                        "PDIRH":"21",
                        "PI":"3",
                        "PIRH":"4",
                        "TI":"1",
                        "TIRH":"22",
                        "TIRL":"33",
                        "time":"2022-07-12 15:35:05",
                        },
                        {"FI":"100",
                        "FM":"12",
                        "FQ":"34",
                        "FQYD":"33",
                        "NAME":"j-7",
                        "PDI":"76",
                        "PDIRH":"21",
                        "PI":"3",
                        "PIRH":"4",
                        "TI":"1",
                        "TIRH":"22",
                        "TIRL":"33",
                        "time":"2022-07-12 15:35:05",
                        },
                        {"FI":"100",
                        "FM":"12",
                        "FQ":"34",
                        "FQYD":"33",
                        "NAME":"j-7",
                        "PDI":"76",
                        "PDIRH":"21",
                        "PI":"3",
                        "PIRH":"4",
                        "TI":"1",
                        "TIRH":"22",
                        "TIRL":"33",
                        "time":"2022-07-12 15:35:05",
                        },
                        {"FI":"100",
                        "FM":"12",
                        "FQ":"34",
                        "FQYD":"33",
                        "NAME":"j-7",
                        "PDI":"76",
                        "PDIRH":"21",
                        "PI":"3",
                        "PIRH":"4",
                        "TI":"1",
                        "TIRH":"22",
                        "TIRL":"33",
                        "time":"2022-07-12 15:35:05",
                        },
                        {"FI":"100",
                        "FM":"12",
                        "FQ":"34",
                        "FQYD":"33",
                        "NAME":"j-7",
                        "PDI":"76",
                        "PDIRH":"21",
                        "PI":"3",
                        "PIRH":"4",
                        "TI":"1",
                        "TIRH":"22",
                        "TIRL":"33",
                        "time":"2022-07-12 15:35:05",
                        },
                    ],[
                        {"FI":"100",
                        "FM":"12",
                        "FQ":"34",
                        "FQYD":"33",
                        "NAME":"j-8",
                        "PDI":"76",
                        "PDIRH":"21",
                        "PI":"3",
                        "PIRH":"4",
                        "TI":"1",
                        "TIRH":"22",
                        "TIRL":"33",
                        "time":"2022-07-12 15:35:05",
                        },
                        {"FI":"100",
                        "FM":"12",
                        "FQ":"34",
                        "FQYD":"33",
                        "NAME":"j-8",
                        "PDI":"76",
                        "PDIRH":"21",
                        "PI":"3",
                        "PIRH":"4",
                        "TI":"1",
                        "TIRH":"22",
                        "TIRL":"33",
                        "time":"2022-07-12 15:35:05",
                        },
                        {"FI":"100",
                        "FM":"12",
                        "FQ":"34",
                        "FQYD":"33",
                        "NAME":"j-8",
                        "PDI":"76",
                        "PDIRH":"21",
                        "PI":"3",
                        "PIRH":"4",
                        "TI":"1",
                        "TIRH":"22",
                        "TIRL":"33",
                        "time":"2022-07-12 15:35:05",
                        },
                        {"FI":"100",
                        "FM":"12",
                        "FQ":"34",
                        "FQYD":"33",
                        "NAME":"j-8",
                        "PDI":"76",
                        "PDIRH":"21",
                        "PI":"3",
                        "PIRH":"4",
                        "TI":"1",
                        "TIRH":"22",
                        "TIRL":"33",
                        "time":"2022-07-12 15:35:05",
                        },
                        {"FI":"100",
                        "FM":"12",
                        "FQ":"34",
                        "FQYD":"33",
                        "NAME":"j-8",
                        "PDI":"76",
                        "PDIRH":"21",
                        "PI":"3",
                        "PIRH":"4",
                        "TI":"1",
                        "TIRH":"22",
                        "TIRL":"33",
                        "time":"2022-07-12 15:35:05",
                        },
                        {"FI":"100",
                        "FM":"12",
                        "FQ":"34",
                        "FQYD":"33",
                        "NAME":"j-8",
                        "PDI":"76",
                        "PDIRH":"21",
                        "PI":"3",
                        "PIRH":"4",
                        "TI":"1",
                        "TIRH":"22",
                        "TIRL":"33",
                        "time":"2022-07-12 15:35:05",
                        },
                        {"FI":"100",
                        "FM":"12",
                        "FQ":"34",
                        "FQYD":"33",
                        "NAME":"j-8",
                        "PDI":"76",
                        "PDIRH":"21",
                        "PI":"3",
                        "PIRH":"4",
                        "TI":"1",
                        "TIRH":"22",
                        "TIRL":"33",
                        "time":"2022-07-12 15:35:05",
                        },

                    ],[
                        {"FI":"100",
                        "FM":"12",
                        "FQ":"34",
                        "FQYD":"33",
                        "NAME":"j-9",
                        "PDI":"76",
                        "PDIRH":"21",
                        "PI":"3",
                        "PIRH":"4",
                        "TI":"1",
                        "TIRH":"22",
                        "TIRL":"33",
                        "time":"2022-07-12 15:35:05",
                        }, 
                        {"FI":"100",
                        "FM":"12",
                        "FQ":"34",
                        "FQYD":"33",
                        "NAME":"j-9",
                        "PDI":"76",
                        "PDIRH":"21",
                        "PI":"3",
                        "PIRH":"4",
                        "TI":"1",
                        "TIRH":"22",
                        "TIRL":"33",
                        "time":"2022-07-12 15:35:05",
                        }, 
                        {"FI":"100",
                        "FM":"12",
                        "FQ":"34",
                        "FQYD":"33",
                        "NAME":"j-9",
                        "PDI":"76",
                        "PDIRH":"21",
                        "PI":"3",
                        "PIRH":"4",
                        "TI":"1",
                        "TIRH":"22",
                        "TIRL":"33",
                        "time":"2022-07-12 15:35:05",
                        }, 
                        {"FI":"100",
                        "FM":"12",
                        "FQ":"34",
                        "FQYD":"33",
                        "NAME":"j-9",
                        "PDI":"76",
                        "PDIRH":"21",
                        "PI":"3",
                        "PIRH":"4",
                        "TI":"1",
                        "TIRH":"22",
                        "TIRL":"33",
                        "time":"2022-07-12 15:35:05",
                        }, 
                        {"FI":"100",
                        "FM":"12",
                        "FQ":"34",
                        "FQYD":"33",
                        "NAME":"j-9",
                        "PDI":"76",
                        "PDIRH":"21",
                        "PI":"3",
                        "PIRH":"4",
                        "TI":"1",
                        "TIRH":"22",
                        "TIRL":"33",
                        "time":"2022-07-12 15:35:05",
                        }, 
                        {"FI":"100",
                        "FM":"12",
                        "FQ":"34",
                        "FQYD":"33",
                        "NAME":"j-9",
                        "PDI":"76",
                        "PDIRH":"21",
                        "PI":"3",
                        "PIRH":"4",
                        "TI":"1",
                        "TIRH":"22",
                        "TIRL":"33",
                        "time":"2022-07-12 15:35:05",
                        }, 
                        {"FI":"100",
                        "FM":"12",
                        "FQ":"34",
                        "FQYD":"33",
                        "NAME":"j-9",
                        "PDI":"76",
                        "PDIRH":"21",
                        "PI":"3",
                        "PIRH":"4",
                        "TI":"1",
                        "TIRH":"22",
                        "TIRL":"33",
                        "time":"2022-07-12 15:35:05",
                        }, 
                    ],
                    [
                        {"FI":"100",
                        "FM":"12",
                        "FQ":"34",
                        "FQYD":"33",
                        "NAME":"j-10",
                        "PDI":"76",
                        "PDIRH":"21",
                        "PI":"3",
                        "PIRH":"4",
                        "TI":"1",
                        "TIRH":"22",
                        "TIRL":"33",
                        "time":"2022-07-12 15:35:05",
                        }, 
                        {"FI":"100",
                        "FM":"12",
                        "FQ":"34",
                        "FQYD":"33",
                        "NAME":"j-10",
                        "PDI":"76",
                        "PDIRH":"21",
                        "PI":"3",
                        "PIRH":"4",
                        "TI":"1",
                        "TIRH":"22",
                        "TIRL":"33",
                        "time":"2022-07-12 15:35:05",
                        }, 
                        {"FI":"100",
                        "FM":"12",
                        "FQ":"34",
                        "FQYD":"33",
                        "NAME":"j-10",
                        "PDI":"76",
                        "PDIRH":"21",
                        "PI":"3",
                        "PIRH":"4",
                        "TI":"1",
                        "TIRH":"22",
                        "TIRL":"33",
                        "time":"2022-07-12 15:35:05",
                        }, 
                        {"FI":"100",
                        "FM":"12",
                        "FQ":"34",
                        "FQYD":"33",
                        "NAME":"j-10",
                        "PDI":"76",
                        "PDIRH":"21",
                        "PI":"3",
                        "PIRH":"4",
                        "TI":"1",
                        "TIRH":"22",
                        "TIRL":"33",
                        "time":"2022-07-12 15:35:05",
                        }, 
                        {"FI":"100",
                        "FM":"12",
                        "FQ":"34",
                        "FQYD":"33",
                        "NAME":"j-10",
                        "PDI":"76",
                        "PDIRH":"21",
                        "PI":"3",
                        "PIRH":"4",
                        "TI":"1",
                        "TIRH":"22",
                        "TIRL":"33",
                        "time":"2022-07-12 15:35:05",
                        }, 
                        {"FI":"100",
                        "FM":"12",
                        "FQ":"34",
                        "FQYD":"33",
                        "NAME":"j-10",
                        "PDI":"76",
                        "PDIRH":"21",
                        "PI":"3",
                        "PIRH":"4",
                        "TI":"1",
                        "TIRH":"22",
                        "TIRL":"33",
                        "time":"2022-07-12 15:35:05",
                        }, 
                        {"FI":"100",
                        "FM":"12",
                        "FQ":"34",
                        "FQYD":"33",
                        "NAME":"j-10",
                        "PDI":"76",
                        "PDIRH":"21",
                        "PI":"3",
                        "PIRH":"4",
                        "TI":"1",
                        "TIRH":"22",
                        "TIRL":"33",
                        "time":"2022-07-12 15:35:05",
                        }, 

                        {"FI":"100",
                        "FM":"12",
                        "FQ":"34",
                        "FQYD":"33",
                        "NAME":"j-10",
                        "PDI":"76",
                        "PDIRH":"21",
                        "PI":"3",
                        "PIRH":"4",
                        "TI":"1",
                        "TIRH":"22",
                        "TIRL":"33",
                        "time":"2022-07-12 15:35:05",
                        }, 
                        {"FI":"100",
                        "FM":"12",
                        "FQ":"34",
                        "FQYD":"33",
                        "NAME":"j-10",
                        "PDI":"76",
                        "PDIRH":"21",
                        "PI":"3",
                        "PIRH":"4",
                        "TI":"1",
                        "TIRH":"22",
                        "TIRL":"33",
                        "time":"2022-07-12 15:35:05",
                        }, {"FI":"100",
                        "FM":"12",
                        "FQ":"34",
                        "FQYD":"33",
                        "NAME":"j-10",
                        "PDI":"76",
                        "PDIRH":"21",
                        "PI":"3",
                        "PIRH":"4",
                        "TI":"1",
                        "TIRH":"22",
                        "TIRL":"33",
                        "time":"2022-07-12 15:35:05",
                        }, 
                        {"FI":"100",
                        "FM":"12",
                        "FQ":"34",
                        "FQYD":"33",
                        "NAME":"j-10",
                        "PDI":"76",
                        "PDIRH":"21",
                        "PI":"3",
                        "PIRH":"4",
                        "TI":"1",
                        "TIRH":"22",
                        "TIRL":"33",
                        "time":"2022-07-12 15:35:05",
                        }, 
                        {"FI":"100",
                        "FM":"12",
                        "FQ":"34",
                        "FQYD":"33",
                        "NAME":"j-10",
                        "PDI":"76",
                        "PDIRH":"21",
                        "PI":"3",
                        "PIRH":"4",
                        "TI":"1",
                        "TIRH":"22",
                        "TIRL":"33",
                        "time":"2022-07-12 15:35:05",
                        }, 
                        {"FI":"100",
                        "FM":"12",
                        "FQ":"34",
                        "FQYD":"33",
                        "NAME":"j-10",
                        "PDI":"76",
                        "PDIRH":"21",
                        "PI":"3",
                        "PIRH":"4",
                        "TI":"1",
                        "TIRH":"22",
                        "TIRL":"33",
                        "time":"2022-07-12 15:35:05",
                        }, 
                        {"FI":"100",
                        "FM":"12",
                        "FQ":"34",
                        "FQYD":"33",
                        "NAME":"j-10",
                        "PDI":"76",
                        "PDIRH":"21",
                        "PI":"3",
                        "PIRH":"4",
                        "TI":"1",
                        "TIRH":"22",
                        "TIRL":"33",
                        "time":"2022-07-12 15:35:05",
                        }, 
                        {"FI":"100",
                        "FM":"12",
                        "FQ":"34",
                        "FQYD":"33",
                        "NAME":"j-10",
                        "PDI":"76",
                        "PDIRH":"21",
                        "PI":"3",
                        "PIRH":"4",
                        "TI":"1",
                        "TIRH":"22",
                        "TIRL":"33",
                        "time":"2022-07-12 15:35:05",
                        }, 
                        {"FI":"100",
                        "FM":"12",
                        "FQ":"34",
                        "FQYD":"33",
                        "NAME":"j-10",
                        "PDI":"76",
                        "PDIRH":"21",
                        "PI":"3",
                        "PIRH":"4",
                        "TI":"1",
                        "TIRH":"22",
                        "TIRL":"33",
                        "time":"2022-07-12 15:35:05",
                        }, 
                        {"FI":"100",
                        "FM":"12",
                        "FQ":"34",
                        "FQYD":"33",
                        "NAME":"j-10",
                        "PDI":"76",
                        "PDIRH":"21",
                        "PI":"3",
                        "PIRH":"4",
                        "TI":"1",
                        "TIRH":"22",
                        "TIRL":"33",
                        "time":"2022-07-12 15:35:05",
                        }, 
                        {"FI":"100",
                        "FM":"12",
                        "FQ":"34",
                        "FQYD":"33",
                        "NAME":"j-10",
                        "PDI":"76",
                        "PDIRH":"21",
                        "PI":"3",
                        "PIRH":"4",
                        "TI":"1",
                        "TIRH":"22",
                        "TIRL":"33",
                        "time":"2022-07-12 15:35:05",
                        }, 
                        {"FI":"100",
                        "FM":"12",
                        "FQ":"34",
                        "FQYD":"33",
                        "NAME":"j-10",
                        "PDI":"76",
                        "PDIRH":"21",
                        "PI":"3",
                        "PIRH":"4",
                        "TI":"1",
                        "TIRH":"22",
                        "TIRL":"33",
                        "time":"2022-07-12 15:35:05",
                        }, 
                        
                    ]
                ],
                active:0,
                flag:true
            }
        },
        mounted() {
            // this.getData();
        },
        methods:{
            // getData(){
            //     getJName({
            //         _size:50
            //     }).then((data)=>{
            //         // console.log(data)
            //         this.list = data.data;
            //         this.getRightData("/"+this.list[0].POINT)
            //     }).catch((e)=>{
            //         console.log(e)
            //     })
            // },
            // getRightData(path){
            //     this.rightData =[];
            //     getRightData(path,{
            //         sort:"-time",
            //         _size:100
            //     }).then((data)=>{
            //         this.rightData = data.data
            //         if(this.rightData[0].hasOwnProperty('FI')){
            //             this.flag = true
            //         }else {
            //             this.flag = false
            //         }
            //     }).catch((e)=>{
            //         console.log(e)
            //     })
            // },
            activeList(num){
                this.active = num
                this.rightData = this.allData[num]
            },
            Ahide(){
                this.$emit('hide',false);
            }
        }
    }
</script>

<style scoped lang="less">
    .pop-box{
        background: url("./../assets/tc-bg.png") no-repeat;
        background-size: 100% 100%;
       width: 775px;
    height: 428px;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%,-50%);
        z-index: 999;
        box-sizing: border-box;
        padding: 78px 33px;
        display: flex;
        justify-content: space-between;
        .close{
            background: url("./../assets/close.png");
            width: 13px;
            height: 12px;
            position: absolute;
            right: 17px;
            top: 41px;

            cursor: pointer;
        }
        .left{
            width: 100px;
            height: 100%;
            overflow: auto;
            /* 设置滚动条的样式 */
            &::-webkit-scrollbar {
                width:5px;
            }
            /* 滚动槽 */
            &::-webkit-scrollbar-track {
                -webkit-box-shadow:inset006pxrgba(0,0,0,0.3);
                border-radius:10px;
            }
            /* 滚动条滑块 */
            &::-webkit-scrollbar-thumb {
                border-radius:10px;
                background:rgba(0,0,0,0.1);
                -webkit-box-shadow:inset006pxrgba(0,0,0,0.5);
            }
            &::-webkit-scrollbar-thumb {
                background:#9dc5fc;
            }
            .list{
                display: flex;
                align-items: center;
                height: 20px;
                cursor: pointer;
                padding-left: 22px;
                box-sizing: border-box;
                position: relative;
                &.active{
                    i{
                        transform: rotate(0deg);
                    }
                }
                i{
                    background: url("./../assets/arrow.png") no-repeat;
                    width: 12px;
                    height: 6px;
                    background-size: 100% 100%;
                    position: absolute;
                    left: 0;
                    transform: rotate(270deg);

                }
                span{
                    font-size: 14px;
                    color: #fff;
                }
            }
        }
    }
    /deep/.el-table--scrollable-y .el-table__body-wrapper{
        /* 设置滚动条的样式 */
        &::-webkit-scrollbar {
            width:5px;
            height: 5px;

        }
        /* 滚动槽 */
        &::-webkit-scrollbar-track {
            -webkit-box-shadow:inset006pxrgba(0,0,0,0.3);
            border-radius:10px;
        }
        /* 滚动条滑块 */
        &::-webkit-scrollbar-thumb {
            border-radius:10px;
            background:rgba(0,0,0,0.1);
            -webkit-box-shadow:inset006pxrgba(0,0,0,0.5);
        }
        &::-webkit-scrollbar-thumb {
            background:#fff;
        }
    }
    /deep/.el-table .cell{
        color: white;
        white-space: nowrap;
    }
    /deep/.el-table tr{
        background-color: transparent;
    }
    /deep/.has-gutter tr th{
        /*border:  0.5px solid black;*/
        text-align: center;
    }
    /deep/.el-table tr td{
        /*border: 0.5px solid black;*/
        text-align: center;
         }
    /deep/table{
        width: 100%;
    }
    /deep/.el-table, .el-table__expanded-cell{
        background-color: transparent;
    }
    /deep/.el-table--border, .el-table--group{
        border: none;
    }
    /deep/.el-table th.el-table__cell{
        background-color: transparent;
    }
    //el-table 取消鼠标悬浮时行高亮效果
    /deep/ .el-table tbody tr {
        pointer-events:none;
    }

</style>